import { render, staticRenderFns } from "./jointSets.vue?vue&type=template&id=fb771b4e&"
import script from "./jointSets.vue?vue&type=script&lang=js&"
export * from "./jointSets.vue?vue&type=script&lang=js&"
import style0 from "./jointSets.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "jointSets.vue"
export default component.exports